import React from 'react';
import {makeStyles, TableRow} from '@material-ui/core';
import {HeaderRowProps} from './types';
import classNames from 'classnames';
import CustomTableCell from "./CustomTableCell";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flex: 1,
    },
    emptyCell: {
        width: 90,
    },

    orderCell: {
        width: 60,
    },
}));

const HeaderRow: <T extends Object>(
    p: HeaderRowProps<T>,
) => React.ReactElement<HeaderRowProps<T>> = ({
    columns,
    isVisible = true,
    dragEnabled,
    dragHeader,
    dragHeaderStyle,
}) => {
    const classes = useStyles();

    if (!isVisible) {
        return <></>;
    }


    return (
        <TableRow className={classes.container}>
            {dragEnabled && !dragHeader && (
                <td
                    className={classNames(classes.emptyCell, dragHeaderStyle)}
                />
            )}
            {dragEnabled && dragHeader && (
                <CustomTableCell
                    className={classNames(classes.orderCell, dragHeaderStyle)}
                >
                    {dragHeader}
                </CustomTableCell>
            )}
            {columns.map((column, id) => {
                const cellProps = column.getHeaderProps();
                return (
                    <CustomTableCell
                        //@ts-ignore
                        key={id}
                        {...cellProps}
                        style={{
                            ...cellProps.style,
                            maxWidth: column.maxWidth,
                            minWidth: column.minWidth,
                            alignSelf: 'center',
                        }}
                        disableHover={column?.id === 'selection' || false}
                        disableEllipsis={column?.id === 'selection' || false}
                    >
                        {column.render('Header')}
                    </CustomTableCell>
                );
            })}
        </TableRow>
    );
};

export default HeaderRow;
